import { useState } from 'react';
import './Landing.css';

function Landing() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    mensaje: ''
  });
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Aquí usamos FormSubmit.co (gratis, sin backend)
    // Los datos llegarán a tu email juanjecontact2@gmail.com
    
    const form = e.target;
    const data = new FormData(form);
    
    try {
      const response = await fetch('https://formsubmit.co/ajax/juanjecontact2@gmail.com', {
        method: 'POST',
        body: data
      });
      
      if (response.ok) {
        setEnviado(true);
        setFormData({ nombre: '', email: '', mensaje: '' });
      } else {
        setError('Hubo un error. Inténtalo de nuevo.');
      }
    } catch (err) {
      setError('Error de conexión. Inténtalo más tarde.');
    }
  };

  return (
    <div className="landing-container">
      {/* Hero section */}
      <div className="hero">
        <div className="hero-content">
          <span className="badge">🚀 Lanzamiento Beta</span>
          <h1>Aprende Marketing Digital<br /><span>Sin Arruinarte</span></h1>
          <p className="hero-description">
            Simula campañas reales en Instagram, Google y TikTok. Descubre qué funciona<br />
            antes de invertir un solo euro. El sandbox definitivo para marketers.
          </p>
          <div className="hero-buttons">
            <a href="/simulator" className="btn-primary">🎮 Probar Simulador →</a>
            <a href="#metakit" className="btn-secondary">📖 Qué es Marketing Studio?</a>
          </div>
          <div style={{ marginTop: '20px', fontSize: '14px' }}>
                <span>Compartir: </span>
                <a href="https://twitter.com/intent/tweet?text=Aprende%20marketing%20sin%20gastar%20dinero%20con%20este%20simulador%20gratuito&url=https://simulator-marketing.vercel.app" target="_blank" rel="noopener noreferrer" style={{ margin: '0 8px', color: 'white' }}>🐦 Twitter</a>
                <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://simulator-marketing.vercel.app" target="_blank" rel="noopener noreferrer" style={{ margin: '0 8px', color: 'white' }}>🔗 LinkedIn</a>
            </div>
        </div>
      </div>

      {/* Métricas destacadas */}
      <div className="stats">
        <div className="stat-item">
          <div className="stat-number">5+</div>
          <div className="stat-label">Plataformas y productos</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">6</div>
          <div className="stat-label">Métricas en tiempo real</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">100%</div>
          <div className="stat-label">Gratuito</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">0€</div>
          <div className="stat-label">Riesgo financiero</div>
        </div>
      </div>

      {/* Sección MetaKit */}
      <div id="metakit" className="metakit-section">
        <h2>¿Qué es <span className="gradient-text">Marketing Studio</span>?</h2>
        <p className="section-subtitle">
          Una herramienta diseñada para que aprendas marketing haciendo, no solo leyendo.
        </p>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Simulaciones Realistas</h3>
            <p>Prueba diferentes presupuestos, calidades de anuncio y targetings. Observa cómo cambian el ROAS, CTR y ventas en tiempo real.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Métricas Clave</h3>
            <p>Impresiones, CTR, CPC, Clics, Ventas, ROAS. Todo lo que necesitas para tomar decisiones informadas.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔄</div>
            <h3>Compara Estrategias</h3>
            <p>Modo comparativa para enfrentar dos configuraciones distintas y ver cuál funciona mejor.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📈</div>
            <h3>Gráficos Evolutivos</h3>
            <p>Visualiza cómo impacta el presupuesto en el ROAS y toma mejores decisiones.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎲</div>
            <h3>Casos Aleatorios</h3>
            <p>Genera combinaciones al azar y aprende de situaciones inesperadas.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💡</div>
            <h3>Análisis Inteligente</h3>
            <p>Recibe feedback personalizado sobre tu campaña y consejos para mejorarla.</p>
          </div>
        </div>
      </div>

      {/* Para quién es */}
      <div className="audience-section">
        <h2>🎓 Para ti si...</h2>
        <div className="audience-grid">
          <div className="audience-item">✅ Estás aprendiendo marketing digital</div>
          <div className="audience-item">✅ Quieres probar estrategias sin gastar dinero</div>
          <div className="audience-item">✅ Eres creador de contenido y quieres recomendar herramientas útiles</div>
          <div className="audience-item">✅ Enseñas marketing y necesitas un recurso práctico</div>
          <div className="audience-item">✅ Trabajas en una agencia y quieres validar hipótesis rápido</div>
          <div className="audience-item">✅ Simplemente tienes curiosidad por cómo funciona la publicidad online</div>
        </div>
      </div>

      {/* Testimonios simulados */}
      <div className="testimonials">
        <h2>⭐ Lo que dicen los primeros usuarios</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <p>"Me ha ayudado a entender por qué mis campañas reales no funcionaban. El simulador me mostró el error en mi targeting."</p>
            <div className="testimonial-author">— Carlos M., Community Manager</div>
          </div>
          <div className="testimonial-card">
            <p>"Increíble para enseñar a mi equipo. Ahora todos entienden ROAS y CPC sin quemar presupuesto real."</p>
            <div className="testimonial-author">— Laura G., Directora de Marketing</div>
          </div>
          <div className="testimonial-card">
            <p>"Lo uso en mis clases. Los alumnos aprenden más en 1 hora que con 10 horas de teoría."</p>
            <div className="testimonial-author">— Javier P., Profesor de Marketing</div>
          </div>
        </div>
      </div>

      {/* Formulario de contacto */}
      <div className="contact-section">
        <h2>📬 ¿Quieres <span className="gradient-text">colaborar</span>?</h2>
        <p className="section-subtitle">
          Si eres creador de contenido, agencia o simplemente tienes una idea, escríbeme.
          <br />Construyamos algo juntos.
        </p>
        
        {!enviado ? (
          <form onSubmit={handleSubmit} className="contact-form">
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_subject" value="Nuevo contacto desde MetaKit Landing" />
            
            <div className="form-group">
              <input
                type="text"
                name="nombre"
                placeholder="Tu nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Tu email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <textarea
                name="mensaje"
                placeholder="Cuéntame tu idea o cómo podríamos colaborar..."
                rows={5}
                value={formData.mensaje}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <button type="submit" className="submit-btn">Enviar mensaje ✨</button>
          </form>
        ) : (
          <div className="success-message">
            <div className="success-icon">✅</div>
            <h3>¡Mensaje enviado!</h3>
            <p>Gracias por contactarme. Te responderé lo antes posible.</p>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>Marketing Studio — Aprende marketing sin riesgo</p>
        <p className="footer-email">📧 juanjecontact2@gmail.com</p>
      </footer>
    </div>
  );
}

export default Landing;